const SET_SECURE_STORAGE_SUCCESS = 'SET_SECURE_STORAGE_SUCCESS';
const SET_SECURE_STORAGE_FAILURE = 'SET_SECURE_STORAGE_FAILURE';
const GET_SECURE_STORAGE_SUCCESS = 'GET_SECURE_STORAGE_SUCCESS';
const GET_SECURE_STORAGE_FAILURE = 'GET_SECURE_STORAGE_FAILURE';
const REMOVE_ITEMS_STORAGE_SUCCESS = 'REMOVE_ITEMS_SECURE_STORAGE_SUCCESS';
const REMOVE_ITEMS_STORAGE_FAILURE = 'REMOVE_ITEMS_SECURE_STORAGE_FAILURE';
const CLEAR_SECURE_STORAGE_SUCCESS = 'CLEAR_SECURE_STORAGE_SUCCESS';
const CLEAR_SECURE_STORAGE_FAILURE = 'CLEAR_SECURE_STORAGE_FAILURE';
const GET_SIZE_SECURE_STORAGE_SUCCESS = 'GET_SIZE_SECURE_STORAGE_SUCCESS';
const GET_SIZE_SECURE_STORAGE_FAILURE = 'GET_SIZE_SECURE_STORAGE_FAILURE';

export {
  SET_SECURE_STORAGE_SUCCESS,
  SET_SECURE_STORAGE_FAILURE,
  GET_SECURE_STORAGE_SUCCESS,
  GET_SECURE_STORAGE_FAILURE,
  REMOVE_ITEMS_STORAGE_SUCCESS,
  REMOVE_ITEMS_STORAGE_FAILURE,
  CLEAR_SECURE_STORAGE_SUCCESS,
  CLEAR_SECURE_STORAGE_FAILURE,
  GET_SIZE_SECURE_STORAGE_SUCCESS,
  GET_SIZE_SECURE_STORAGE_FAILURE,
};
